import type { Element } from "React";
type Props = {
  className?: string;
};

const LogoEighteenPlus = (props: Props): Element<"svg"> => (
  <svg
    version="1.1"
    id="Calque_1"
    x="0px"
    y="0px"
    viewBox="992 -993.2 2267.7 2267.7"
    style={{
      enableBackground: "new 992 -993.2 2267.7 2267.7",
    }}
    className={props.className}
  >
    <g id="Calque_1_1_">
      <circle
        style={{
          fill: "#c94b4b",
          stroke: "#000000",
          strokeMiterlimit: 10,
        }}
        cx="2125.9"
        cy="140.7"
        r="885.2"
      />
    </g>
    <g id="Calque_2">
      <g>
        <g>
          <path
            style={{
              fill: "#FFFFFF",
            }}
            d="M1590.6-180.7h90.5V427h-131V-46.2l-105.2,25.9l-27.6-108.6L1590.6-180.7z"
          />
          <path
            style={{
              fill: "#FFFFFF",
            }}
            d="M1684.1,430h-137V-42.4l-104.3,25.7l-29-114.3l176.4-52.7h93.9V430z M1553.1,424h125v-601.7H1591
				l-170.1,50.8L1447-24l106-26.1L1553.1,424L1553.1,424z"
          />
        </g>
        <g>
          <path
            style={{
              fill: "#FFFFFF",
            }}
            d="M2264.6,257.2c0,28.2-5.9,53.3-17.7,75.4c-11.8,22.1-28,40.8-48.7,56c-20.7,15.2-45.3,26.9-73.7,34.9
				s-59.3,12.1-92.7,12.1c-33.3,0-64.2-4.2-92.7-12.5s-53-20.1-73.7-35.3c-20.7-15.2-36.9-33.6-48.7-55.2
				c-11.8-21.5-17.7-45.5-17.7-72c0-37.3,8.2-67.4,24.6-90.1c16.4-22.7,40.6-41.5,72.8-56.5c-23.6-14.4-42.2-31.9-56-52.6
				c-13.8-20.7-20.7-47.4-20.7-80.2c0-23,5-44.7,15.1-65.1c10-20.4,24.4-38.1,43.1-53c18.7-14.9,40.9-26.7,66.8-35.3
				c25.9-8.6,54.9-12.9,87.1-12.9c31.6,0,60.5,4.3,86.6,12.9c26.1,8.6,48.6,20.4,67.2,35.3c18.7,15,33,32.6,43.1,53
				c10,20.4,15.1,42.1,15.1,65.1c0,32.8-6.9,59.5-20.7,80.2c-13.8,20.7-32.5,38.2-56,52.6c31,16.1,55,34.9,72,56.5
				C2256.2,192.1,2264.6,221,2264.6,257.2z M2136.2,249.9c0-24-9.8-42.4-29.3-55.3c-19.5-12.8-44.5-19.3-75-19.3s-55.5,6.4-75,19.3
				s-29.3,31.3-29.3,55.3c0,21.7,9.2,39.7,27.6,54c18.4,14.3,44,21.4,76.7,21.4s58.3-7.1,76.7-21.4
				C2127,289.6,2136.2,271.6,2136.2,249.9z M2118.1-3.5c0-18.9-7.5-35.4-22.4-49.7c-15-14.3-36.2-21.4-63.8-21.4
				c-27.6,0-48.9,7-63.8,21c-15,14-22.4,30.4-22.4,49.3c0,21.7,7.8,39.6,23.3,53.6s36.5,21,62.9,21c26.4,0,47.4-6.9,62.9-20.6
				C2110.3,35.9,2118.1,18.2,2118.1-3.5z"
          />
          <path
            style={{
              fill: "#FFFFFF",
            }}
            d="M2031.9,438.7c-33.4,0-64.9-4.2-93.5-12.6s-53.8-20.4-74.6-35.8c-21-15.4-37.6-34.3-49.6-56.1
				c-12-21.9-18-46.6-18-73.4c0-37.8,8.5-68.7,25.1-91.8c15.8-21.8,39-40.3,69.1-55.1c-21.7-14-39.2-31-52.3-50.6
				c-14.1-21.1-21.2-48.6-21.2-81.8c0-23.3,5.2-45.7,15.4-66.4s25-38.9,43.9-54s41.6-27.2,67.7-35.8c26-8.7,55.7-13.1,88-13.1
				c31.8,0,61.2,4.4,87.6,13.1c26.4,8.7,49.3,20.7,68.2,35.8c18.9,15.2,33.7,33.3,43.9,54c10.2,20.7,15.4,43.1,15.4,66.4
				c0,33.2-7.1,60.7-21.2,81.8c-13.1,19.6-30.8,36.7-52.5,50.7c29.1,15.7,52,34.1,68.3,54.8c17.3,22,26.1,51.8,26.1,88.5
				c0,28.5-6.1,54.4-18,76.8c-12,22.4-28.6,41.6-49.6,57c-20.9,15.4-46,27.3-74.7,35.4C2096.8,434.6,2065.3,438.7,2031.9,438.7z
				 M2031.9-182c-31.7,0-60.7,4.3-86.1,12.8c-25.4,8.5-47.6,20.2-65.9,34.8c-18.3,14.6-32.5,32.1-42.3,52
				c-9.8,19.9-14.8,41.3-14.8,63.8c0,32,6.8,58.4,20.2,78.5c13.5,20.2,32,37.6,55.1,51.7l4.8,2.9l-5.1,2.4
				c-31.6,14.7-55.7,33.3-71.7,55.5c-15.9,22.1-24,51.8-24,88.3c0,25.8,5.8,49.5,17.3,70.5c11.5,21.1,27.6,39.3,47.8,54.2
				c20.3,15,44.8,26.7,72.8,34.9c28.1,8.2,59,12.4,91.8,12.4c32.9,0,63.8-4,91.8-12c28-7.9,52.4-19.5,72.7-34.4
				c20.2-14.9,36.3-33.4,47.8-55s17.3-46.5,17.3-74c0-35.3-8.3-63.9-24.8-84.8c-16.6-21.1-40.5-39.8-71-55.7l-4.7-2.5l4.5-2.8
				c23.1-14.1,41.6-31.4,55.1-51.7c13.4-20.1,20.2-46.5,20.2-78.5c0-22.4-5-43.8-14.8-63.8c-9.8-19.9-24-37.4-42.3-52
				c-18.3-14.6-40.6-26.4-66.3-34.8C2091.9-177.7,2063-182,2031.9-182z M2031.9,328.3c-33.3,0-59.7-7.4-78.6-22.1
				c-19.1-14.8-28.7-33.8-28.7-56.4c0-25,10.3-44.4,30.7-57.8c19.9-13.1,45.7-19.8,76.6-19.8s56.7,6.7,76.6,19.8
				c20.3,13.4,30.7,32.8,30.7,57.8c0,22.6-9.7,41.6-28.7,56.4C2091.6,320.9,2065.2,328.3,2031.9,328.3z M2031.9,178.3
				c-29.7,0-54.4,6.3-73.3,18.8c-18.8,12.4-28,29.6-28,52.8c0,20.7,8.9,38,26.4,51.6c17.8,13.8,42.9,20.8,74.9,20.8
				c31.9,0,57.1-7,74.9-20.8c17.5-13.6,26.4-31,26.4-51.6c0-23.1-9.1-40.4-28-52.8C2086.3,184.7,2061.6,178.3,2031.9,178.3z
				 M2031.9,73.2c-27.1,0-48.9-7.3-64.9-21.8c-16.1-14.5-24.3-33.3-24.3-55.8c0-19.6,7.9-36.9,23.4-51.5
				c15.4-14.5,37.6-21.8,65.8-21.8s50.4,7.5,65.9,22.3s23.3,32.3,23.3,51.9c0,22.5-8.2,41.1-24.3,55.4
				C2080.8,66,2059,73.2,2031.9,73.2z M2031.9-71.6c-26.7,0-47.4,6.8-61.7,20.2c-14.2,13.3-21.5,29.2-21.5,47.1
				c0,20.7,7.5,38,22.3,51.3c14.9,13.4,35.4,20.2,60.9,20.2c25.6,0,46.1-6.7,60.9-19.8c14.8-13.1,22.3-30.2,22.3-50.9
				c0-17.9-7.2-33.9-21.5-47.5C2079.3-64.7,2058.5-71.6,2031.9-71.6z"
          />
        </g>
        <g>
          <path
            style={{
              fill: "#FFFFFF",
            }}
            d="M2518.1-91h122.4V63.3h156v119.8h-156v155.2h-122.4V183.1h-156V63.3h156V-91z"
          />
          <path
            style={{
              fill: "#FFFFFF",
            }}
            d="M2643.5,341.3h-128.4V186.1h-156V60.3h156V-94h128.4V60.3h156v125.8h-156V341.3z M2521.1,335.3h116.4V180.1
				h156V66.3h-156V-88h-116.4V66.3h-156v113.8h156V335.3z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default LogoEighteenPlus;
